import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const GET_LIST_BY_NAME_URL = 'inbounddb-lists/v1/lists/type';
const CREATE_LIST_URL = 'inbounddb-lists/v1/lists';
const FETCH_LISTS_URL = 'inbounddb-lists/v1/segments-ui/searchLists';
const ADD_TO_LIST_URL = 'inbounddb-lists/v1/segments-ui/add-to-list-from-search';
const ADD_TO_LIST_VIA_REPORTING_URL = 'reporting/v1/list/add-from-config';
export const PAGE_COUNT = 50;
export const fetchLists = (currOffset = 0, objectTypeId, searchQuery) => {
  return http.post(FETCH_LISTS_URL, {
    data: {
      count: PAGE_COUNT,
      offset: currOffset,
      properties: ['hs_processing_type', 'hs_list_id', 'hs_object_type_id', 'hs_list_name'],
      listFilterProperties: {
        objectTypeId,
        limitExempt: false,
        processingTypes: ['SNAPSHOT', 'MANUAL']
      },
      includePrivate: false,
      query: searchQuery
    }
  });
};
export const fetchListByName = (listName, objectTypeId) => http.get(`${GET_LIST_BY_NAME_URL}/${objectTypeId}/${listName}`);
export const createList = (listName, objectTypeId) => http.post(CREATE_LIST_URL, {
  query: {
    referenceType: 'USER_PORTAL',
    referenceId: `${PortalIdParser.get()}`,
    public: true
  },
  data: {
    processingType: 'MANUAL',
    name: listName,
    objectTypeId
  }
});
export const populateListFromSearch = (listId, objectTypeId, filterGroups) => http.post(ADD_TO_LIST_URL, {
  query: {
    listId,
    sourceListCanBeEmpty: true
  },
  data: {
    portalId: `${PortalIdParser.get()}`,
    objectTypeId,
    filterGroups
  }
});
export const populateListFromReportConfig = (listId, config) => http.post(ADD_TO_LIST_VIA_REPORTING_URL, {
  query: {
    listId
  },
  data: config
});